
window._ = require('lodash');
window.Popper = require('popper.js').default;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');

    require('magnific-popup');
    require('jquery-match-height');

} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

window.consoleNotice = function(type=null) {
  if ( type === 'success' ) {
    return 'background-color:#bada55;color:white;padding:0 10px;border-radius:3px;';
  } else if ( type === 'error' ) {
    return 'background-color:tomato;color:white;padding:0 10px;border-radius:3px;';
  } else if ( type === 'warn' ) {
    return 'background-color:#ffcc00;color:white;padding:0 10px;border-radius:3px;';
  } else {
    return 'background-color:#137bb5;color:white;padding:0 10px;border-radius:3px;';
  }
}

window.getCategoryHex = function( category ) {
    switch(category) {
        case 'WE':
            return '#E65722';
            break;
        case 'HO':
            return '#FDB913';
            break;
        case 'FH':
            return '#7BC143';
            break;
        case 'PE':
            return '#4BB8EF';
            break;
        case 'MC':
            return '#7C2B83';
            break;
        default:
            return;
    }
}

window.getCategoryColor = function( category ) {
    switch(category) {
        case 'WE':
            return 'orange';
            break;
        case 'HO':
            return 'yellow';
            break;
        case 'FH':
            return 'green';
            break;
        case 'PE':
            return 'blue';
            break;
        case 'MC':
            return 'purple';
            break;
        default:
            return;
    }
}

// function for dynamic sorting
window.compareValues = function(key, order='asc') {
  return function(a, b) {
    if(!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
        return 0;
    }

    const varA = (typeof a[key] === 'string') ?
      a[key].toUpperCase() : a[key];
    const varB = (typeof b[key] === 'string') ?
      b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return (
      (order == 'desc') ? (comparison * -1) : comparison
    );
  };
}

window.sort_by = function() {
   let fields = [].slice.call(arguments),
       n_fields = fields.length;

   return function(A,B) {
       let a, b, field, key, primer, reverse, result, i;

       for(i = 0; i < n_fields; i++) {
           result = 0;
           field = fields[i];

           key = typeof field === 'string' ? field : field.name;

           a = A[key];
           b = B[key];

           if (typeof field.primer  !== 'undefined'){
               a = field.primer(a);
               b = field.primer(b);
           }

           reverse = (field.reverse) ? -1 : 1;

           if (a<b) result = reverse * -1;
           if (a>b) result = reverse * 1;
           if(result !== 0) break;
       }
       return result;
   }
};



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js